import { KeyboardArrowDownOutlined, KeyboardArrowRightOutlined, RouteOutlined } from '@mui/icons-material'
import { Button } from '@mui/material'
import { MODEL_ROUTES } from 'constants/index'
import { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'

export function LocalhostNav() {
  const navigate = useNavigate()
  const [isOpen, setIsOpen] = useState(false)
  const [expanded, setExpanded] = useState(null)
  const containerRef = useRef(null)

  const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'

  useEffect(() => {
    if (isOpen && containerRef.current) {
      containerRef.current.focus()
    }
    return () => {
      setExpanded(false)
    }
  }, [isOpen])

  const handleBlur = (event) => {
    if (containerRef.current && !containerRef.current.contains(event.relatedTarget)) {
      setIsOpen(false)
    }
  }

  const handleToggleExpand = (section) => {
    setExpanded(expanded === section ? null : section)
  }

  const groupTitleStyle = {
    fontSize: '11px',
    fontWeight: '700',
    textTransform: 'uppercase',
    color: '#718096',
    letterSpacing: '0.5px',
    marginBottom: '6px',
    padding: '4px',
    borderRadius: '4px',
    transition: 'background-color 0.15s',
    ':hover': { backgroundColor: '#1a1b26' },
  }

  const buttonStyle = {
    width: '100%',
    textAlign: 'left',
    padding: '10px 12px',
    backgroundColor: '#222533',
    color: '#e2e8f0',
    border: '1px solid #2d3142',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '13px',
    transition: 'background-color 0.15s',
  }

  const buttonHoverStyle = {
    backgroundColor: '#2e3349',
    color: '#ffffff',
  }

  if (!isLocalhost) return null

  return (
    <div
      ref={containerRef}
      tabIndex={-1}
      onBlur={handleBlur}
      style={{ position: 'fixed', bottom: '15px', left: '4rem', zIndex: 99999, fontFamily: 'sans-serif' }}
    >
      {!isOpen && (
        <Button
          onClick={() => setIsOpen(true)}
          variant="contained"
          title="Abrir Devtools de Rotas"
          sx={{
            borderRadius: '5rem',
          }}
        >
          <RouteOutlined />
        </Button>
      )}

      {isOpen && (
        <div
          style={{
            backgroundColor: '#13141f',
            color: '#efefef',
            width: '320px',
            borderRadius: '8px',
            boxShadow: '0 8px 24px rgba(0,0,0,0.5)',
            border: '1px solid #2d3142',
            overflow: 'hidden',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '10px 14px',
              backgroundColor: '#1a1b26',
              borderBottom: '1px solid #2d3142',
            }}
          >
            <span style={{ fontSize: '12px', fontWeight: 'bold', letterSpacing: '0.5px', color: '#2196F3' }}>
              NAVIGATION DEVTOOLS
            </span>
            <Button
              onClick={() => setIsOpen(false)}
              style={{
                background: 'none',
                border: 'none',
                color: '#a0aec0',
                cursor: 'pointer',
                fontSize: '14px',
                padding: '4px 8px',
              }}
            >
              Fechar
            </Button>
          </div>

          <div
            style={{
              padding: '12px',
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
              maxHeight: '350px',
              overflowY: 'auto',
            }}
          >
            <div>
              <div style={groupTitleStyle}>Geral</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <Button
                  onClick={() => navigate('/accounts')}
                  style={buttonStyle}
                  onMouseEnter={(e) => Object.assign(e.currentTarget.style, buttonHoverStyle)}
                  onMouseLeave={(e) => Object.assign(e.currentTarget.style, buttonStyle)}
                >
                  Conexão de contas
                </Button>

                <Button
                  onClick={() => navigate(MODEL_ROUTES.FLOWS)}
                  style={buttonStyle}
                  onMouseEnter={(e) => Object.assign(e.currentTarget.style, buttonHoverStyle)}
                  onMouseLeave={(e) => Object.assign(e.currentTarget.style, buttonStyle)}
                >
                  Flows
                </Button>
              </div>
            </div>

            <div>
              <Button
                variant="text"
                onClick={() => handleToggleExpand('hsm')}
                style={{
                  ...groupTitleStyle,
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  cursor: 'pointer',
                  userSelect: 'none',
                  width: '100%',
                }}
              >
                <span>Recursos de HSM</span>
                <span style={{ fontSize: '9px', color: '#a0aec0' }}>
                  {expanded === 'hsm' ? <KeyboardArrowDownOutlined /> : <KeyboardArrowRightOutlined />}
                </span>
              </Button>

              {expanded === 'hsm' && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginTop: '4px' }}>
                  <Button
                    onClick={() => navigate(MODEL_ROUTES.SENT_MESSAGE_LIST)}
                    style={buttonStyle}
                    onMouseEnter={(e) => Object.assign(e.currentTarget.style, buttonHoverStyle)}
                    onMouseLeave={(e) => Object.assign(e.currentTarget.style, buttonStyle)}
                  >
                    listagem de disparos
                  </Button>
                  <Button
                    onClick={() => navigate(MODEL_ROUTES.MODEL_LIST)}
                    style={buttonStyle}
                    onMouseEnter={(e) => Object.assign(e.currentTarget.style, buttonHoverStyle)}
                    onMouseLeave={(e) => Object.assign(e.currentTarget.style, buttonStyle)}
                  >
                    listagem de modelos
                  </Button>
                  <Button
                    onClick={() => navigate(MODEL_ROUTES.CREATE_MODEL_HI)}
                    style={buttonStyle}
                    onMouseEnter={(e) => Object.assign(e.currentTarget.style, buttonHoverStyle)}
                    onMouseLeave={(e) => Object.assign(e.currentTarget.style, buttonStyle)}
                  >
                    Criar Template (Hi Broker)
                  </Button>
                  <Button
                    onClick={() => navigate(MODEL_ROUTES.CREATE_MODEL_PARTNER)}
                    style={{ ...buttonStyle, opacity: 0.6 }}
                    onMouseEnter={(e) => Object.assign(e.currentTarget.style, { ...buttonHoverStyle, opacity: 1 })}
                    onMouseLeave={(e) => Object.assign(e.currentTarget.style, { ...buttonStyle, opacity: 0.6 })}
                  >
                    Criar Template (deprecated)
                  </Button>
                </div>
              )}
            </div>

            <div>
              <Button
                variant="text"
                onClick={() => handleToggleExpand('reports')}
                style={{
                  ...groupTitleStyle,
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  cursor: 'pointer',
                  userSelect: 'none',
                  width: '100%',
                }}
              >
                <span>Relatórios</span>
                <span style={{ fontSize: '9px', color: '#a0aec0' }}>
                  {expanded === 'reports' ? <KeyboardArrowDownOutlined /> : <KeyboardArrowRightOutlined />}
                </span>
              </Button>

              {expanded === 'reports' && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginTop: '4px' }}>
                  <Button
                    onClick={() => navigate(`relatorios/hsm`)}
                    style={buttonStyle}
                    onMouseEnter={(e) => Object.assign(e.currentTarget.style, buttonHoverStyle)}
                    onMouseLeave={(e) => Object.assign(e.currentTarget.style, buttonStyle)}
                  >
                    relatório de HSM
                  </Button>
                  <Button
                    onClick={() => navigate(`relatorios/analyticReport`)}
                    style={buttonStyle}
                    onMouseEnter={(e) => Object.assign(e.currentTarget.style, buttonHoverStyle)}
                    onMouseLeave={(e) => Object.assign(e.currentTarget.style, buttonStyle)}
                  >
                    relatório analítico
                  </Button>
                  <Button
                    onClick={() => navigate(`relatorios/whatsapp-export-history`)}
                    style={buttonStyle}
                    onMouseEnter={(e) => Object.assign(e.currentTarget.style, buttonHoverStyle)}
                    onMouseLeave={(e) => Object.assign(e.currentTarget.style, buttonStyle)}
                  >
                    histórico de exportação
                  </Button>
                  <Button
                    onClick={() => navigate(`relatorios/conversion`)}
                    style={buttonStyle}
                    onMouseEnter={(e) => Object.assign(e.currentTarget.style, buttonHoverStyle)}
                    onMouseLeave={(e) => Object.assign(e.currentTarget.style, buttonStyle)}
                  >
                    eventos e conversões
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
